import { Observable } from 'rxjs'

import { request, parseAPIError, DownloadRequest } from '../../common/api'

import * as actionTypes from './actionTypes'
import * as actionCreators from './actionCreators'

import { resolveModelState } from '../../common/table/helpers'
import * as tableModelActionTypes from '../../common/table/actionTypes'

// Fetch

const fetchReportCostCenterTrafficEpic = (action$, store) => {
    const tableIdentifier = 'report_cost_center_traffic'

    return action$
        .ofType(actionTypes.FETCH, tableModelActionTypes.CONFIGURATION_CHANGED)
        .filter(action => action.type !== tableModelActionTypes.CONFIGURATION_CHANGED || action.payload.tableIdentifier === tableIdentifier)
        .switchMap(action => {
            const modelState = resolveModelState(tableIdentifier, store.getState(), action)

            return Observable.concat(
                Observable.of({
                    type: actionTypes.FETCH_STARTED,
                }),
                request({
                    method: 'POST',
                    path: `report-cost-center-traffic`,
                    body: {
                        filters: modelState.get('filters').toJS(),
                    },
                })
                    .switchMap(ajaxResponse => Observable.of(actionCreators.fetchReportCostCenterTrafficFulfilled(ajaxResponse.response)))
                    .catch(error => Observable.of(actionCreators.fetchReportCostCenterTrafficRejected(parseAPIError(error))))
                    .takeUntil(action$.ofType(actionTypes.FETCH_CANCELLED, actionTypes.FETCH))
            )
        })
}

// Export

const exportReportCostCenterTrafficEpic = (action$, store) => {
    const tableIdentifier = 'report_cost_center_traffic'

    return action$.ofType(actionTypes.EXPORT).switchMap(action => {
        const modelState = resolveModelState(tableIdentifier, store.getState(), action)

        const filters = JSON.stringify(modelState.get('filters').toJS())
        const token = store.getState().auth.get('accessToken')

        new DownloadRequest({
            url: `report-cost-center-traffic/export?filters=${filters}&token=${token}`,
        }).run()

        return Observable.concat(
            Observable.of({
                type: actionTypes.EXPORT_FULFILLED,
            })
        )
    })
}

// Fetch details

const fetchReportCostCenterTrafficDetailsEpic = action$ =>
    action$.ofType(actionTypes.FETCH_DETAILS).switchMap(action =>
        Observable.concat(
            Observable.of({
                type: actionTypes.FETCH_DETAILS_STARTED,
            }),
            request({
                method: 'POST',
                path: `report-cost-center-traffic/details`,
                body: {
                    filters: action.payload,
                },
            })
                .switchMap(ajaxResponse => Observable.of(actionCreators.fetchReportCostCenterTrafficDetailsFulfilled(ajaxResponse.response)))
                .catch(error => Observable.of(actionCreators.fetchReportCostCenterTrafficDetailsRejected(parseAPIError(error))))
                .takeUntil(action$.ofType(actionTypes.FETCH_DETAILS_CANCELLED))
        )
    )

// Export details

const exportReportCostCenterTrafficDetailsEpic = (action$, store) =>
    action$.ofType(actionTypes.EXPORT_DETAILS).switchMap(action => {
        const filters = JSON.stringify(action.payload)
        const token = store.getState().auth.get('accessToken')

        new DownloadRequest({
            url: `report-cost-center-traffic/details/export?filters=${filters}&token=${token}`,
        }).run()

        return Observable.concat(
            Observable.of({
                type: actionTypes.EXPORT_DETAILS_FULFILLED,
            })
        )
    })

// Fetch details vehicles

const fetchReportCostCenterTrafficDetailsVehiclesEpic = action$ =>
    action$.ofType(actionTypes.FETCH_DETAILS_VEHICLES).switchMap(action =>
        Observable.concat(
            Observable.of({
                type: actionTypes.FETCH_DETAILS_VEHICLES_STARTED,
            }),
            request({
                method: 'POST',
                path: `report-cost-center-traffic/details-vehicles`,
                body: {
                    filters: action.payload,
                },
            })
            .switchMap(ajaxResponse => Observable.of(actionCreators.fetchReportCostCenterTrafficDetailsVehiclesFulfilled(ajaxResponse.response)))
            .catch(error => Observable.of(actionCreators.fetchReportCostCenterTrafficDetailsVehiclesRejected(parseAPIError(error))))
            .takeUntil(action$.ofType(actionTypes.FETCH_DETAILS_VEHICLES_CANCELLED))
        )
    )

// Export details vehicles

const exportReportCostCenterTrafficDetailsVehiclesEpic = (action$, store) =>
    action$.ofType(actionTypes.EXPORT_DETAILS_VEHICLES).switchMap(action => {
        const filters = JSON.stringify(action.payload)
        const token = store.getState().auth.get('accessToken')

        new DownloadRequest({
            url: `report-cost-center-traffic/details-vehicles/export?filters=${filters}&token=${token}`,
        }).run()

        return Observable.concat(
            Observable.of({
                type: actionTypes.EXPORT_DETAILS_VEHICLES_FULFILLED,
            })
        )
    })

export default [
    fetchReportCostCenterTrafficEpic,
    exportReportCostCenterTrafficEpic,
    fetchReportCostCenterTrafficDetailsEpic,
    exportReportCostCenterTrafficDetailsEpic,
    fetchReportCostCenterTrafficDetailsVehiclesEpic,
    exportReportCostCenterTrafficDetailsVehiclesEpic,
]
